define('TescoMobile_Sso/js/view/account/dashboard/bills-and-payments',['uiComponent', 'ko', 'Magento_Customer/js/customer-data', 'Magento_Catalog/js/price-utils'], function (Component, ko, customerData, priceUtils) {
  "use strict";

  return Component.extend({
    defaults: {
      template: 'TescoMobile_Sso/account/dashboard/bills-and-payments',
      viewBillsUrl: ''
    },
    latestBill: null,
    hasBills: false,
    visible: false,
    initObservable: function () {
      this._super();
      this.observe(['hasBills', 'latestBill', 'visible']);
      return this;
    },
    initialize: function () {
      this._super();
      const billing = customerData.get('billing');
      this.updateLatestBill(billing());
      billing.subscribe(this.updateLatestBill, this);
    },
    updateLatestBill: function (billing) {
      if (Array.isArray(billing === null || billing === void 0 ? void 0 : billing.bills)) {
        this.visible(true);
        if ((billing === null || billing === void 0 ? void 0 : billing.bills.length) > 0) {
          this.hasBills(true);
          this.latestBill(this.formatPrice(billing.bills[0].total));
        } else {
          this.hasBills(false);
          this.latestBill(null);
        }
      }
    },
    formatPrice: function (price) {
      return priceUtils.formatPrice(price, {
        decimalSymbol: '.',
        integerRequired: false,
        pattern: "£%s",
        precision: 2,
        requiredPrecision: 2
      });
    }
  });
});

